// Game Areas Configuration
export const AREAS = [
  {
    id: 'neon-street',
    name: 'AWAKENING',
    emoji: '⚡',
    boss: 'DJ SPARK',
    color: '#FF6B9D',
    range: [1, 20],
    unlocked: true,
  },
  {
    id: 'cyber-cafe',
    name: 'CHALLENGER',
    emoji: '💎',
    boss: 'MC LATTE',
    color: '#00F5D4',
    range: [21, 40],
    unlocked: false,
  },
  {
    id: 'galaxy-club',
    name: 'WARRIOR',
    emoji: '🚀',
    boss: 'STAR QUEEN',
    color: '#9B5DE5',
    range: [41, 60],
    unlocked: false,
  },
  {
    id: 'sunset-beach',
    name: 'MASTER',
    emoji: '🎯',
    boss: 'WAVE MASTER',
    color: '#FEE440',
    range: [61, 80],
    unlocked: false,
  },
  {
    id: 'genkai-tower',
    name: 'LIMIT BREAK',
    emoji: '🌟',
    boss: 'MASTER G',
    color: 'rainbow',
    range: [81, 100],
    unlocked: false,
  },
]

// Combo System
export const COMBO_LEVELS = [
  { min: 0, max: 4, label: null, effect: 'normal' },
  { min: 5, max: 9, label: 'ナイス！', effect: 'nice' },
  { min: 10, max: 19, label: 'グレート！', effect: 'great' },
  { min: 20, max: 29, label: 'アメージング！', effect: 'amazing' },
  { min: 30, max: 999, label: 'フィーバー！', effect: 'fever' },
]

// VIBE Gauge System
export const VIBE_LEVELS = [
  { min: 0, max: 25, emoji: '🥶', label: 'コールド', bgEffect: 'cold' },
  { min: 26, max: 50, emoji: '😎', label: 'クール', bgEffect: 'cool' },
  { min: 51, max: 75, emoji: '🔥', label: 'ホット', bgEffect: 'hot' },
  { min: 76, max: 100, emoji: '⚡', label: 'フィーバー', bgEffect: 'fever' },
]

// Scoring
export const SCORING = {
  BASE_POINTS: 100,
  COMBO_MULTIPLIER: 10,
  TIME_BONUS_PER_SECOND: 5,
}

// Timing
export const TIMING = {
  QUESTION_TIME_LIMIT: 30, // seconds
  ANIMATION_DURATION: 300, // ms
  FEEDBACK_DISPLAY: 800, // ms
}

// Game Modes
export const GAME_MODES = {
  FREE: 'free',
  RANDOM: 'random',
  WEAK: 'weak',
  FLASHCARD: 'flashcard',
}
